module.exports = __webpack_public_path__ + "img/65.d72d94e7.jpg";